<form [formGroup]="claimForm" novalidate>
  <div class="form-group">
    <label>{{ 'CLAIMS.type' | translate }}</label>
    <gp-tree-select class="form-control"
                    formControlName="name"
                    [tree]="claimTypeTree"
                    [isSorted]="true"
                    [readOnly]="readOnly || isTaskDescription"
                    ngDefaultControl>
    </gp-tree-select>
  </div>
  <div class="form-group" *ngIf="!readOnly && !isSelectedClaimTypeUnlimited()">
    <label>{{ 'CLAIMS.request_limit' | translate }}</label>
    <div class="input-group-inline">
      <number-input
        [type]="'decimal'"
        [readOnly]="true"
        formControlName="requestLimit"
        id="requestLimit"
        ngDefaultControl
        [maxDigits]="4">
      </number-input>
      <span class="input-group-addon input-group-label input-disabled">
            {{translatedAmountUnit}}
          </span>
    </div>
  </div>
  <div class="form-group">
    <label>{{ 'CLAIMS.current_request' | translate }}</label>
    <div class="form-inline">
      <div class="input-group-inline">
        <number-input [type]="'decimal'"
                      [readOnly]="!isClaimAvailable || readOnly"
                      formControlName="value"
                      id="value"
                      ngDefaultControl
                      [maxDigits]="4">
        </number-input>
        <span class="input-group-addon input-group-label input-disabled">
              {{translatedAmountUnit}}
            </span>
      </div>
      <ul class="error-list" [attr.data-hidden]="isClaimAvailable || readOnly">
        <li *ngIf="!isClaimAvailable">
          {{ 'CLAIMS.msg_limit_value_has_not_been_calculated_yet' | translate }}
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="isTaskDescription">
    <div class="form-group">
      <label for="beginDate">{{ 'COMMON.beginDate' | translate }}</label>
      <datepicker-input
        formControlName="beginDate"
        [readOnly]="readOnly"
        ngDefaultControl
        id="beginDate">
      </datepicker-input>
    </div>
    <div class="form-group">
      <label for="endDate">{{ 'COMMON.endDate' | translate }}</label>
      <datepicker-input
        formControlName="endDate"
        [readOnly]="readOnly"
        ngDefaultControl
        id="endDate">
      </datepicker-input>
    </div>
  </div>
  <div class="form-group">
    <label for="comment">{{ 'COMMON.comment' | translate }}</label>
    <textarea class="textarea-control"
              formControlName="comment"
              [ngClass]="{'input-disabled': readOnly || isTaskDescription}"
              rows="5"
              [readOnly]="readOnly || isTaskDescription"
              id="comment"></textarea>
  </div>
  <gp-variable-zones
    [contractId]="contractId"
    [cliRegId]="cliRegId"
    [data]="selectedClaimType"
    [name]="getSelectedClaimTypeName()"
    [isEss]="isEss"
    [readOnly]="readOnly || isTaskDescription"
    *ngIf="isClaimAvailable || readOnly">
  </gp-variable-zones>
</form>
